
import React, { useState, useEffect, useContext } from 'react';
import { addBusinessDays } from 'date-fns';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';

import { TiCancel } from "react-icons/ti";
import { IoMdCheckmark } from 'react-icons/io';
import { BsFillSendFill } from "react-icons/bs";
import { MdOutlineCancel ,  MdRestore, MdPreview} from 'react-icons/md';
import { Layout, Header } from '../../../../components';
import { handleApi, formatCurrency, formatMediumDate } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RestorePayment = () => {
  const location = useLocation();
  const { pay } = location.state || {};
  const clearPayeeFields = () => {
    return {
      payee_name: '',
      id_type: '',
      id_no: '',
      account_holder_name: '',
      bank_account_number: '',
      bank_branch: '',
      bank_name: '',
      cheque_no: '',
      credit_card_number: '',
      credit_card_expiration_date: '',
      cvv: '',
      paypal_email: '',
      currency: '',
      mobile_number: '',
      service_provider: ''
    };
  };
  
  const [payment, setPayment] = useState({
    state: pay?.state,
    invoice_id: pay?.id || 0,
    method_id: pay?.method_id,
    amount: pay?.amount || 0,
    payee: clearPayeeFields(),  // Calling the function to initialize the payee object
  });
    
  
    
  const [invoice, setInvoice] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [formattedPaymentMethods, setFormattedPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null); // The customer object
  const [installments, setInstallments] = useState([]);
  const [showPaymentButton, setShowPaymentButton] = useState(true);
  const [isInstallment,setIsInstallment] = useState(false);
  const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
  const navigate = useNavigate();

  // Update isInstallment whenever pay changes
  // Update isInstallment when pay.amount or pay.invoice.totalTaxedPrice changes


  useEffect(() => {
    const fetchData = async () => {
      try {
        const inv=  await fetchInvoice(); // Fetch invoice data
        const isInstall =((inv?.payments && inv?.payments.length > 0)|| (Number(pay.amount)< Number(inv.totalPriceInclusive)));

        //const isInstall = Array.isArray((inv?.payments && inv?.payments.length > 0)||(pay?.Amount<inv?.totalPriceInclusive))
        //const isInstall = Number.isFinite(pay?.Amount) && Number.isFinite(inv?.totalPriceInclusive) && pay?.Amount < inv?.totalPriceInclusive;

    
        setIsInstallment(isInstall)
       
       // setIsInstallment((Array.isArray(inv?.payments) && inv?.payments.length > 0)||( pay?.Amount < inv?.totalPriceInclusive))
        setInvoice(inv)    
        const methods = await fetchPaymentMethods(); 
        setSelectedPaymentMethod(methods.name)
        } catch (error) {console.error('Error fetching data:', error);
              } finally {
                  // Mark loading as complete after the fetches are done
                  //setLoading(false);
              }
          };
    
          fetchData();
      }, []); // Empty dependency array ensures this runs only once when the component mounts
    
  useEffect(() => {
    setIsInstallment(pay?.amount < pay?.invoice?.totalTaxedPrice);
  }, [pay?.amount, pay?.invoice?.totalTaxedPrice]);

  useEffect(() => {
    if (pay?.method_id) {
      const preselectedMethod = formattedPaymentMethods.find(method => method.value === pay.method_id);
      setSelectedPaymentMethod(preselectedMethod);
    }
  }, [formattedPaymentMethods, pay?.method_id]);

  const fetchPaymentMethods = async () => {
          const apiEndpoint = 'payment_methods';
          const apiMethod = 'GET';
          const cleanedData = {};
          const parameters = {id:pay?.method_id};
      
          try {
            const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
            if (response.error) {console.error(`Error fetching id types : ${response.errorMessage}`);return;}
            const { status, data } = response;
            if (status === 200) {
          
              return data[0] ;} else {toast.error(`Error ${status}: ${response.statusText}`);}
          } catch (error) {toast.error(error.message || 'An unexpected error occurred.');}
        };
  
        const fetchInvoice = async () => {
          const apiEndpoint = 'purchase/invoices';
          const apiMethod = 'GET';
          const cleanedData = {};
          const parameters = {id:pay?.invoice_id};
      
          try {
            const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
            if (response.error) {console.error(`Error fetching id types : ${response.errorMessage}`);return;}
            const { status, data } = response;
            if (status === 200) {
              return data[0] ;} else {toast.error(`Error ${status}: ${response.statusText}`);}
          } catch (error) {toast.error(error.message || 'An unexpected error occurred.');}
        };
  
    
    
    
  
  const handleApiWithTimeout = async (url, data, userData, method, parameters, timeout = 5000) => { // Timeout helper for API calls
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await handleApi(url, data, userData, method, parameters, { signal: controller.signal });
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        toast.error('Request timed out');
      } else {
        toast.error('Error: ' + error.message);
      }
      throw error;
    } finally {
      clearTimeout(timeoutId);
    }
  };
  
  
  const handlePaymentChange = async (field, value) => {
   setPayment((prevPayment) => {
     let newPayment = { ...prevPayment };
 
    
    if (field === 'installments') {   
       setIsInstallment(value);   // Handle the installment checkbox change
       newPayment.amount = value ? prevPayment.installment_amount : pay?.totalTaxedPrice || 0;
     }else if (field === 'installment_amount') { newPayment.amount = value; 
     }else if (field === 'method_id') { // Find the selected payment method object
      const selectedMethod = formattedPaymentMethods.find(option => option.value === value);
      newPayment.method_id = value;
      setSelectedPaymentMethod(selectedMethod);  // Set the object with value and label
      newPayment.payee = clearPayeeFields();  // Reset all payee fields
     } else {newPayment[field] = value;    // If it's not a payee field, update the field directly on payment
    }
 

     return newPayment;
   });
 };
  
 const handleSubmit = async () => {
     const changedOrder = { state: "draft", id: pay.id }; // Ensure this is populated if needed
     const parameters = {}; // Make sure this is populated if needed
     setIsLoading(true); // Start loading
 
     try {
       const response = await handleApiWithTimeout('purchase/payments', changedOrder, userData, 'PUT', parameters);
       if (response.status === 200) {
         toast.success('Payment cancelled successfully.');

       } else {
         toast.error('Error cancelling payment.', response.statusText);
       }
     } catch (error) {
       console.error("API Error:", error);  // Log any error that might occur
       toast.error('Error cancelling payment: ' + error.message);
     } finally {
       setIsLoading(false); // Always stop loading after request is done
       setActionCount(actionCount + 1); // Update action count
     }
   };
  

  const handleClose = () => { 
    navigate(-1);  // Navigate back when closing the form
  };

  const subtotal = pay?.invoice?.totalUntaxedPrice || 0;
  const discountAmount = pay?.totalDiscount || 0;
  const subtotalAfterDiscount = subtotal - discountAmount;
  const taxAmount = pay?.invoice?.totalTax || 0;
  const grandTotal = subtotalAfterDiscount + taxAmount;

  const formattedGrandTotal = formatCurrency(grandTotal.toFixed(2));

  return (
    
    <Layout>
    <div className="m-4 bg-black rounded-xl shadow-2xl p-1">
      <ToastContainer position="top-center" autoClose={2000} />
      <div className="text-center py-4 border-b">
        <div className="w-full flex justify-end">
          <button
            className="text-white hover:text-gray-300 py-1 px-2 rounded transition-all duration-300"
            title="Close"
            onClick={handleClose}
          >
            <MdOutlineCancel size={24} color={currentColor}/>
          </button>
        </div>      
        <div className="mx-4 text-white">
          <Header category="Purchase" title="Restore  Payment" color={currentColor}/>
        </div>
      </div>        

      {/* Loading State */}
      {isLoading ? (
        <div className="flex flex-col items-center py-6">
          <Audio height="80" width="80" color="white" ariaLabel="loading" />
          <p className="mt-4 text-white">Processing payment...</p>
        </div>
      ) : (
        <div className="bg-white p-2 my-2 rounded-xl shadow-2xl">
          <div className="flex justify-end p-2 bg-gray-100 rounded-xl">
            <button
              onClick={handleSubmit}
              className="text-white px-3 py-2 font-bold rounded-lg flex bg-blue-500 hover:bg-blue-600 transition-all duration-300 transform hover:scale-105"
            >
              <MdRestore  size={25} />
              <span>Restore</span>
            </button>
          </div>


          
      
          
            {/* all information */}
            <div className=" my-4   mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
            

             

            {/* supplier information */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Supplier Information</p>
              <div className="space-y-1">
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Supplier Name:</label>
                  <span>{invoice?.partners?.name || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Contact Person:</label>
                  <span>{invoice?.partners?.contact_person || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Phone:</label>
                  <span>{invoice?.partners?.phone_number || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Email:</label>
                  <span>{invoice?.partners?.email || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Invoice No.:</label>
                  <span className='font-bold'>{invoice?.invoice_no || 'N/A'}</span>
                </div>
              </div>
            </div>
             {/* End Supplier Information Section */}

            {/* Invoice Information Section */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Invoice Details</p>
              <div className="space-y-1">
                              <div className="flex justify-between text-sm">
                                <label className="font-medium">Due Date:</label>
                                <span>{formatMediumDate(invoice?.due_date)}</span>
                              </div>
                              <div className="flex justify-between text-sm">
                                <label className="font-medium">Order ID:</label>
                                <span>{invoice?.p_orders?.reference}</span>
                              </div>
                             
                              <div className="flex justify-between text-sm">
                                <span>Invoice Amount:</span>
                                <span className='font-bold'>{formatCurrency(invoice.totalPriceInclusive)}</span>
                              </div>
                              <div className="flex justify-between text-sm">
                                <span>Total Paid:</span>
                                 <span>{formatCurrency(invoice?.totalPaidAmount || 0)}</span>
                              </div>
                              <div className="flex justify-between text-sm">
                                <span>Outstanding Balance:</span>
                                   <span className='font-bold'>{formatCurrency(invoice?.totalPriceInclusive - invoice?.totalPaidAmount || 0)}</span>
                              </div>
                            </div>
            </div>
            {/* End Invoice SInformation Section */}
            {/* supplier information */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Payment Information</p>
              <div className="space-y-1">
                
                {/* Installment Option */}
                <div className="flex items-center">
                    <input
                      type="checkbox"
                      checked={isInstallment}
                      onChange={() => handlePaymentChange('installments', !isInstallment)}  // Call handlePaymentChange with 'installments' field
                      className="mr-2"
                      disabled="true"
                    />
                    <label className="text-sm text-gray-700 font-semibold">Paying in Installments</label>
                  </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Payment Method:</label>
                  <span>{selectedPaymentMethod}</span>
             
                </div>
          
                                   
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Paid Amount:</label>
                  <span className='font-bold'>{pay.amount || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Created Date:</label>
                  <span>{formatMediumDate(pay?.date || 'N/A')}</span>
                </div>
               
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Status:</label>
                  <span
                    className={`uppercase font-bold ml-2 ${
                      pay?.state === 'draft'
                      ? 'text-yellow-700'
                      : pay?.state === 'approved'
                      ? 'text-blue-600'
                      : pay?.state === 'cancelled'
                      ? 'text-red-600'
                      : pay?.state === 'deleted'
                      ? 'text-gray-400'
                      : pay?.state === 'paid'
                      ? 'text-green-600'
                      : 'text-yellow-500' // Default to yellow for 'Pending' or unassigned states
                    }`}
                  >
                    {pay?.state || 'Pending'}
                  </span>
                </div>

       
                  
              </div>
            </div>
             {/* End Payment Information Section */}

            {/* Payee Information Section */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Payee Details</p>
              <div className="space-y-1">
                

                 {/* Payment Method is cash */}
                 {/* Payment Method is cash */}
                 { selectedPaymentMethod?.toLowerCase() === "cash" && ( 
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Payee Full Name</label>
                    <span>{pay?.method_details?.payee_name}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Identification  Type:</label>
                    <span>{pay?.method_details?.id_type}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Identification Number:</label>
                    <span>{pay?.method_details?.id_no}</span>
                  </div>
                  </>
               
                )}

                {/* Payment by bank transfer */}
                { selectedPaymentMethod?.toLowerCase() === "bank transfer" && ( 
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Account #</label>
                    <span>{pay?.method_details?.account_no}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Name:</label>
                    <span>{pay?.method_details?.bank_name}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Branch:</label>
                    <span>{pay?.method_details?.bank_branch}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Account Holder</label>
                    <span>{pay?.method_details?.account_holder}</span>
                  </div>
                  
                  
                  </>
               
                )}

                {/* Payment by credit card  */}
                { selectedPaymentMethod?.toLowerCase() === "credit card" && ( 
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Card Number</label>
                    <span>{pay?.method_details?.credit_card_number}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Expiration Date:</label>
                    <span>{pay?.method_details?.expiration_date}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">CVV:</label>
                    <span>{pay?.method_details?.cvv}</span>
                  </div>
                  </>
               
                )}
                {/* Payment by paypal  */}
                { selectedPaymentMethod?.toLowerCase() === "paypal" && ( 
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">PayPal Email</label>
                    <span>{pay?.method_details?.PayPal_email}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Currency:</label>
                    <span>{pay?.method_details?.currency}</span>
                  </div>
                  </>
               
                )}
                {/* Payment by cheque  */}
                { selectedPaymentMethod?.toLowerCase() === "cheque" && ( 
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Cheque Number.</label>
                    <span>{pay?.method_details?.cheque_no}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Name:</label>
                    <span>{pay?.method_details?.bank_name}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Branch:</label>
                    <span>{pay?.method_details?.bank_branch}</span>
                  </div>
                  </>
               
                )}
                  {/* Payment by mobile money */}
                  { selectedPaymentMethod?.toLowerCase() === "mobile money" && ( 
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Mobile Number.</label>
                    <span>{pay?.method_details?.cheque_no}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Name:</label>
                    <span>{pay?.method_details?.mobile_number}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Service Provider:</label>
                    <span>{pay?.method_details?.service_provider}</span>
                  </div>
                  </>
               
                )}
               
              </div>
            </div>
            
       
       
            
          </div>
            
            {/* end all information */}

         

         

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4 mt-4">
            <button
              onClick={handleClose}
              className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-red-700 flex items-center gap-2"
            >
              <MdOutlineCancel size={20} />
              <span>Close</span>
            </button>
          </div>    
      </div>
  )}
</div>
</Layout>
    

  );
};
export default RestorePayment;
